<template>
    <div class="app-content" id="app">
      <router-view name="nav"></router-view>
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'APP',
  mounted() {
    this.$Message.config({
      top: 70,
      duration: 2
    })
  }
}
</script>

<style lang="scss">
  @import '@/styles/index.scss';
  .app-content {
    background: #F6F7F9;
    height: 100%;
  }
</style>
